import classNames from 'classnames'
import { useField } from 'formik'
import { useState } from 'react'

import type { ReactElement } from 'react'
import type { IAP_STATUS } from '~/types/iap'
import type { IIapOption } from '~/types/option'

import IapInputModal from './Modal'

import ActionInput from '../ActionInput'
import InputControls from '../Controls'

import { IapStatusBadge } from '~/components/Badges'
import Modal from '~/components/Modal'
import { formatDuration } from '~/utils/date'

import './styles.scss'

interface Props {
  className?: string
  disabled?: boolean
  name: string
  onDelete?: VoidFunction
  placeholderKey: string
}

const iapDetails = (value: IIapOption) => {
  if (value?.price) {
    return (
      <div className="iap-details">
        <div className="iap-details__value">{value.value}</div>
        <table className="iap-details__table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Price</th>
              <th>Free trial period</th>
              <th>Subscription period</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <IapStatusBadge value={value.status.toLowerCase() as IAP_STATUS} />
              </td>
              <td>{value.price.price_formatted}</td>
              <td>{formatDuration(value.price.trial_period_days, 'd')}</td>
              <td>{formatDuration(value.price.subscription_period_days, 'd')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
  return null
}

const IapInput = ({ className, disabled, name, onDelete }: Props): ReactElement => {
  const [, { error, value }, { setValue }] = useField<IIapOption | undefined>(name)

  const componentClasses = classNames('iap-input', className)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleDelete = () => {
    onDelete ? onDelete() : setValue(undefined)
  }

  const toggleModal = (isModalOpen: boolean) => () => setIsModalOpen(isModalOpen)

  return (
    <div className={componentClasses}>
      <div className="iap-input__row">
        <ActionInput
          disabled={disabled}
          isValid={!!value && !error}
          label="In-app"
          onAddClick={toggleModal(true)}
          onInputClick={toggleModal(true)}
        >
          {value ? value.label : undefined}
        </ActionInput>
        {value ? <InputControls copyValue={value.value} onDelete={!disabled ? handleDelete : undefined} /> : null}
      </div>
      {value ? <div className="iap-input__row">{iapDetails(value)}</div> : null}
      <Modal isOpen={isModalOpen} onCloseModal={toggleModal(false)}>
        <IapInputModal name={name} onItemClick={toggleModal(false)} />
      </Modal>
    </div>
  )
}

export default IapInput
